import type { Dispatch, SetStateAction } from 'react';
import type { AgentChatStreamMeta } from '../../../utils/agentApi';

/** Maps Edge SSE meta events to a short UI line for the assistant bubble. */
export function applyAgentStreamMeta(
  ev: AgentChatStreamMeta,
  setStreamActivity: Dispatch<SetStateAction<string | null>>
): void {
  if ('ready' in ev && ev.ready) return;
  if (!('phase' in ev)) return;
  if (ev.phase === 'context') return;
  if (ev.phase === 'tool' && ev.status === 'start') {
    if (ev.tool === 'tavily_search') {
      setStreamActivity(ev.queryPreview ? `Searching: ${ev.queryPreview}` : 'Searching the web…');
    } else if (ev.tool === 'serper_web_search') {
      setStreamActivity(ev.queryPreview ? `Web search: ${ev.queryPreview}` : 'Searching the web…');
    } else {
      setStreamActivity(`Using tool: ${ev.tool}…`);
    }
  } else if (ev.phase === 'tool' && ev.status === 'done') {
    setStreamActivity('Composing answer…');
  } else if (ev.phase === 'llm_round' && ev.status === 'start') {
    setStreamActivity((prev) => prev ?? 'Thinking…');
  }
}
